<template>
  <div>
    <v-layout row container justify-center>
      <v-dialog v-model="dialog" persistent max-width="800">
        <v-card light class="pr-5 pl-5 pt-4 pb-4">
          <span class="partido-title">{{ partidoDescription }}</span>
          <br>
          <span color="grey-lighten-1" class="subheadline">Nueva consulta</span>
          <v-card-text>
          <form>
            <v-text-field v-model="title" :error-messages="titleErrors" label="Asunto"
                          required @input="$v.title.$touch()"></v-text-field>
            <v-select v-model="departamento"
                      :items="items"
                      item-text="nombre"
                      item-value="id"
                      :error-messages="departamentoErrors"
                      label="Departamento" required @change="$v.departamento.$touch()"
                      no-data-text="No hay datos disponibles"></v-select>
            <v-textarea v-model="cuerpo"
                        :error-messages="cuerpoErrors"
                        label="Detalle"
                        required @input="$v.cuerpo.$touch()"></v-textarea>
            <AttachFile ref="fileInput" @upload="uploadFiles"></AttachFile>
            <v-btn color="blue-grey-lighten-4" @click="closeDialog">Volver</v-btn>
            <v-btn @click="openFileDirectory" color="primary" :disabled="saving">Agregar Adjuntos</v-btn>
            <v-btn @click="uploadAllFiles" color="primary" :disabled="saving">Crear</v-btn>
          </form>
        </v-card-text>
        </v-card>
      </v-dialog>
    </v-layout>
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'
import AttachFile from '../../../common/ui/AttachFile'
import { s3UploadMixin } from '../../../mixins/s3UploadMixin'

export default {
  mixins: [validationMixin, s3UploadMixin],

  validations: {
    title: { required },
    departamento: { required },
    cuerpo: { required }
  },

  components: {
    AttachFile
  },

  props: {
    partidoDescription: null,
    partidoId: null
  },

  data () {
    return {
      loading: false,
      saving: false,
      title: '',
      departamento: null,
      cuerpo: '',
      items: [],
      files: [],
      file: null,
      dialog: false
    }
  },
  computed: {
    titleErrors () {
      const errors = []
      if (!this.$v.title.$dirty) return errors
      !this.$v.title.required && errors.push('El título es requerido.')
      return errors
    },
    departamentoErrors () {
      const errors = []
      if (!this.$v.departamento.$dirty) return errors
      !this.$v.departamento.required && errors.push('El departamento es requerido.')
      return errors
    },
    cuerpoErrors () {
      const errors = []
      if (!this.$v.cuerpo.$dirty) return errors
      !this.$v.cuerpo.required && errors.push('El cuerpo es requerido.')
      return errors
    }
  },
  methods: {
    fetchData () {
      this.axios
        .get('departamento')
        .then(response => {
          this.items = response.data
          this.loading = false
        })
        .catch(error => {
          this.$store.commit('setErrorMsg', error)
        })
    },
    submit () {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        this.saving = true
        const payload = {
          title: this.title,
          departamento: this.departamento,
          cuerpo: this.cuerpo,
          partido: this.partidoId
        }
        this.axios
          .post('/consulta-partido/new', payload)
          .then((response) => {
            if (this.assets.length > 0) {
              this.axios
                .put('/mensaje/upload-s3/' + response.data.mensaje.id, { assets: this.assets })
                .catch(error => { this.$store.commit('setErrorMsg', error) })
            }
            this.$router.go()
          })
          .catch(error => {
            this.$store.commit('setErrorMsg', error)
            this.saving = false
          })
      }
    },
    uploadFiles (newFiles) {
      this.files = newFiles
    },
    openFileDirectory () {
      this.$refs.fileInput.onPickFile()
    },
    showDialog () {
      this.dialog = true
    },
    closeDialog () {
      this.dialog = false
    }
  },
  created () {
    this.loading = true
    this.fetchData()
  }
}
</script>

<style>
.subheadline {
  color: lightslategray;
  font-size: 1.4em;
  color: rgb(99, 95, 95);
  padding-top: 1.5em;
  margin-top: 2em;
}

.partido-title{
  color: lightslategray;
  font-size: 1.8em;
  color: rgb(60, 145, 197);
  padding-top: 1.5em;
  margin-top: 2em;
}
</style>
